import { useState } from "react";
import { Link } from "react-router-dom";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [showSearch, setShowSearch] = useState(false);
  const [showShopDropdown, setShowShopDropdown] = useState(false);

  return (
    <nav className="bg-white text-gray-800 shadow-lg sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <div className="flex items-center space-x-2">
            <img src="/logo.png" alt="VeggieFresh" className="h-20 w-15" />
          </div>

          {/* Desktop Navigation Links */}
          <div className="hidden md:flex items-center space-x-6">
            {/* Home */}
            <Link to="/" className="hover:text-green-600 transition">Home</Link>

            {/* Shop Dropdown */}
            <div
              className="relative"
              onMouseEnter={() => setShowShopDropdown(true)}
              onMouseLeave={() => setShowShopDropdown(false)}
            >
            </div>

            {/* Other links */}
            <Link to="/quality" className="hover:text-green-600 transition">Quality</Link>
            <Link to="/brand-page" className="hover:text-green-600 transition">Our brand</Link>
            <Link to="/about-page" className="hover:text-green-600 transition">About</Link>
            <Link to="/contact-page" className="hover:text-green-600 transition">Contact</Link>
          </div>

          {/* Right Icons - Only Search */}
          <div className="hidden md:flex items-center space-x-4">
            {/* Search */}
            <div className="relative">
              <button
                onClick={() => setShowSearch(!showSearch)}
                className="p-2 hover:bg-green-100 rounded-full transition text-gray-600"
              >
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                </svg>
              </button>
              {showSearch && (
                <div className="absolute right-0 mt-2 w-64 animate-slideIn">
                  <input
                    type="text"
                    placeholder="Search vegetables..."
                    className="w-full px-4 py-2 rounded-md border border-gray-300 text-gray-800 focus:outline-none focus:ring-2 focus:ring-green-400"
                    autoFocus
                  />
                </div>
              )}
            </div>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden flex items-center">
            <button onClick={() => setIsOpen(!isOpen)} className="focus:outline-none text-gray-600">
              <svg className="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                {isOpen ? (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                ) : (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                )}
              </svg>
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      <div
        className={`md:hidden transition-all duration-300 ease-in-out ${
          isOpen ? "max-h-96 opacity-100" : "max-h-0 opacity-0 overflow-hidden"
        }`}
      >
        <div className="px-2 pt-2 pb-3 space-y-1 bg-white border-t border-gray-200">
          {/* Mobile Search */}
          <div className="px-3 py-2">
            <input
              type="text"
              placeholder="Search vegetables..."
              className="w-full px-3 py-2 rounded-md border border-gray-300 text-gray-800 focus:outline-none focus:ring-2 focus:ring-green-400"
            />
          </div>
          {/* Mobile Links */}
          <Link to="/" className="block px-3 py-2 rounded-md hover:bg-green-100 text-gray-800" onClick={() => setIsOpen(false)}>Home</Link>
          <Link to="/quality" className="block px-3 py-2 rounded-md hover:bg-green-100 text-gray-800" onClick={() => setIsOpen(false)}>Quality</Link>
          <Link to="/brand-page" className="block px-3 py-2 rounded-md hover:bg-green-100 text-gray-800" onClick={() => setIsOpen(false)}>Our brand</Link>
          <Link to="/about" className="block px-3 py-2 rounded-md hover:bg-green-100 text-gray-800" onClick={() => setIsOpen(false)}>About</Link>
          <Link to="/contact" className="block px-3 py-2 rounded-md hover:bg-green-100 text-gray-800" onClick={() => setIsOpen(false)}>Contact</Link>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;



